(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name UserController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('UserController', UserController);

    UserController.$inject = ["UserService","$timeout","$location",'$window'];

    function UserController(UserService,$timeout,$location,$window)
    {
        var vm = this;
        vm.code = 0;
        vm.username = "";
        vm.password = "";
        vm.msgerror = "";
        vm.msg = "";
        vm.errmsg ="";
        vm.finalpass ="";
        vm.msgemail ="";
        vm.msglogin = false;

        vm.login = function(){
            UserService.Login(vm).then(function(data){ 
                vm.msgerror = data.msg;
                vm.msglogin = data.msglogin;
                vm.msgemail = data.msgemail;
                //vm.username = data.username;
                //vm.password = "";
                //console.log("mensaje login",vm.msglogin);
            
                if (data.slugMarketing ) {
                    window.location = data.slugMarketing;
                    window.open(data.slugMarketing,'_system');
                }
            });
        } ;
        
        vm.loading = false;
        vm.recovery = function(){
            if(vm.loading)
                return ;
            vm.loading = true;
            UserService.Recuperarpassword(vm).then(function(data){
                vm.loading = false;
                vm.msgerror = data.msgerror;
                vm.msgemail = data.msgemail;
                //vm.username = data.username;
                //console.log(vm.username);
            },function(data){
                vm.loading = false;
            });
        };

        vm.changepassword = function(form){
            UserService.Changepassword(vm).then(function(data){
                vm.finalpass = data.finalpass;
                vm.password = data.password;
                vm.password_rep = data.password_rep;
                vm.msgerror = data.msgerror;
                //console.log("1",vm.finalpass);
                if ( vm.finalpass != undefined) {
                    form.$setPristine();
                    form.$setUntouched();
                    //console.log("2",vm.finalpass);

                }
         
            });
        };

        vm.reset = function(form) {
            vm.username ="";
            vm.password ="";
            vm.reseteado = true;
            form.$setPristine();
        }

        vm.saveprofile = function(form){
            UserService.editProfile(vm).then(function(data){
            //console.log(vm.password);
            //console.log(vm.password_rep);
                if (vm.password && vm.password_rep) {
                    vm.changepassword(form);
                }
                vm.guardado = data.guardado;
                //console.log(vm.guardado);
            })
        }

        
        
    }

})();